import { render, staticRenderFns } from "./BecomeLeaderForm.vue?vue&type=template&id=03f9b872&scoped=true&"
import script from "./BecomeLeaderForm.vue?vue&type=script&lang=js&"
export * from "./BecomeLeaderForm.vue?vue&type=script&lang=js&"
import style0 from "./BecomeLeaderForm.vue?vue&type=style&index=0&id=03f9b872&lang=scss&scoped=true&"
import style1 from "./BecomeLeaderForm.vue?vue&type=style&index=1&id=03f9b872&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f9b872",
  null
  
)

export default component.exports